import { useMediaQuery } from '@mantine/hooks';
export const _useMedia = () => {
    const isPc = useMediaQuery(`(min-width: 1201px)`);
    return {
        isPc,
        isPhone: !isPc,
    };
};
